import React from 'react';
import PropTypes from 'prop-types';
import IframeEmbed from '../IframeEmbed';
import { apiZedocGetPatientBundleToken } from '../../../common/api/zedoc';

const PatientBundle = ({ recipientId }) => (
  <IframeEmbed
    apiSpec={apiZedocGetPatientBundleToken}
    params={{ recipientId }}
    title="Patient Bundle"
    toolName="patient bundle tool"
  />
);

PatientBundle.propTypes = {
  recipientId: PropTypes.string.isRequired,
};

export default PatientBundle;
